module.exports = __webpack_public_path__ + "static/media/banner-ganha-1gb.9fb88eae.svg";